import * as React from 'react';
import MainRoute from  './routes';
import { history } from './services/mobx-router';
import { Router } from 'react-router';
import { observer, inject } from 'mobx-react';

@inject('apolloStore')
@observer
class App extends React.Component<any, any> {
  render() {
    return (
      <Router history={history}>
        <MainRoute />
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx